module.exports = __webpack_public_path__ + "a45da2379c2d91bc553e24437a03df43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/pirate-ship.png
// module id = 2856
// module chunks = 0